// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Config from "../../../../../../../../Config.bs.js";
import * as Belt_Option from "../../../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Api from "@react-google-maps/api";

function getGoogleConfig(config) {
  return {
          map_elem_id: config.map_elem_id,
          center: config.center,
          zoom: Belt_Option.getWithDefault(config.zoom, 11),
          mapContainerClassName: config.mapContainerClassName,
          clickableIcons: config.clickableIcons,
          onLoad: config.onLoad,
          onTilesLoaded: config.onTilesLoaded,
          options: config.options,
          ref: config.ref,
          onClick: undefined,
          mapTypeId: undefined,
          onBoundsChanged: undefined
        };
}

function MapComponentMod(Props) {
  var lib_nameOpt = Props.lib_name;
  var config = Props.config;
  var children = Props.children;
  var lib_name = lib_nameOpt !== undefined ? lib_nameOpt : /* GoogleMap */0;
  if (lib_name) {
    return null;
  }
  var googleConfig = getGoogleConfig(config);
  return React.createElement(Api.LoadScriptNext, {
              googleMapsApiKey: Config.Env.getGoogleMapsApiKey(undefined),
              id: "script-loader",
              libraries: Config.Env.orderDetailGMapLibs,
              children: React.createElement(Api.GoogleMap, {
                    center: googleConfig.center,
                    zoom: googleConfig.zoom,
                    id: googleConfig.map_elem_id,
                    mapContainerClassName: googleConfig.mapContainerClassName,
                    clickableIcons: googleConfig.clickableIcons,
                    onLoad: googleConfig.onLoad,
                    onTilesLoaded: googleConfig.onTilesLoaded,
                    options: googleConfig.options,
                    ref: googleConfig.ref,
                    children: children
                  })
            });
}

var make = MapComponentMod;

export {
  getGoogleConfig ,
  make ,
  
}
/* react Not a pure module */
